export const RouteGetMerchflow_merchflowId_FlowUpdateProducts =
  "/merchflow/:merchflowId/flow-update/products";

export type ResponseGetMerchflow_merchflowId_FlowUpdateProducts = {
  addableProducts: FlowUpdateProduct[];
  removableProducts: FlowUpdateProduct[];
};

export interface FlowUpdateProduct {
  productCode: string;
  name: string;
  variant?: string | null;
  cdt1?: string | null;
  cdt2?: string | null;
}
